import {
    TouchableOpacity,
    View
} from "react-native";
import stylesheet from "./stylesheet";
import {
    NCoreUIKitLocalize,
    NCoreUIKitTheme,
    PageContainer,
    Text
} from "ncore-ui-kit";
import {
    useNavigation
} from "@react-navigation/native";
import type RootStackParamList from "../../../../navigation/type";
import {
    ChevronRightIcon,
    LanguagesIcon,
    NewspaperIcon
} from "lucide-react-native";
import {
    type NativeStackNavigationProp
} from "@react-navigation/native-stack";

const SettingsMain = () => {
    const navigation = useNavigation<NativeStackNavigationProp<RootStackParamList>>();
    const {
        localize
    } = NCoreUIKitLocalize.useContext();
    const {
        radiuses,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext();

    const renderCard = (
        title: string,
        description: string,
        icon: React.ReactNode,
        onPress: () => void
    ) => {
        return <TouchableOpacity
            style={[
                stylesheet.cardContainer,
                {
                    backgroundColor: colors.project.brandWhite,
                    borderRadius: radiuses.md,
                    padding: spaces.spacingLg
                }
            ]}
            onPress={onPress}
        >
            <View
                style={[
                    stylesheet.cardContent,
                    {
                        gap: spaces.spacingMd
                    }
                ]}
            >
                {icon}
                <View>
                    <Text
                        variant="titleMediumSize"
                    >
                        {title}
                    </Text>
                    <Text
                        customColor={colors.content.text.mid}
                        variant="bodyMediumSize"
                    >
                        {description}
                    </Text>
                </View>
            </View>
            <ChevronRightIcon
                color={colors.content.icon.mid}
                size={24}
            />
        </TouchableOpacity>;
    };

    return <PageContainer
        isScrollable={true}
    >
        <View
            style={[
                stylesheet.container,
                {
                    padding: spaces.spacingXl,
                    gap: spaces.spacingLg
                }
            ]}
        >
            {renderCard(
                localize("menu-settings-news-categories"),
                localize("menu-settings-news-categories-desc"),
                <NewspaperIcon
                    color={colors.content.icon.high}
                    size={24}
                />,
                () => {
                    navigation.navigate("SettingsNewsCategories");
                }
            )}
            {renderCard(
                localize("menu-settings-system-locales"),
                localize("menu-settings-system-locales-desc"),
                <LanguagesIcon
                    color={colors.content.icon.high}
                    size={24}
                />,
                () => {
                    navigation.navigate("SettingsSystemLocales");
                }
            )}
        </View>
    </PageContainer>;
};

export default SettingsMain;
